const I = 10, _ = 1024, G = 7, N = 1e4, E = 10, R = 7, T = 100;
export {
  T as CHANNEL_GROUPING_LIMIT,
  R as CHANNEL_GROUPING_TERM_SIZE,
  G as CONTINENT_GROUPING_TERM_SIZE,
  _ as COUNTRY_GROUPING_TERM_SIZE,
  I as GEO_GROUPING_LIMIT,
  E as TEAM_GROUPING_LIMIT,
  N as TEAM_GROUPING_TERM_SIZE
};
